import React, { useState } from 'react'
import clsx from 'clsx'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Col } from 'react-bootstrap'
import { useMutation } from '@apollo/client'
import { UPDATE_TPV } from '../../../../../utils/GraphQLAPI'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import moment from 'moment'
import TooltipCommon from '../../../../sharedComponent/CustomTooltip/TooltipCommon'
interface RecordingInfoProps {
  tpvId: string
  data: any
  handleRecordTab: (e: any) => void
  customerData: any
  tpvStatus: string
}

const RecordingInfo = ({ tpvId, data, handleRecordTab, customerData, tpvStatus }: RecordingInfoProps) => {
  const MySwal = withReactContent(Swal)
  const [tab, setTab] = useState<number>(0)
  const [btnShow, setBtnShow] = useState<boolean>(false)
  const [dataFeed, setDataFeed] = useState<boolean>(false)
  const [newDisposition, setNewDisposition] = useState<string>('')
  const recordingInfoSchema = Yup.object().shape({
    disposition: Yup.string().trim().max(2000, 'Disposition should not exceed 2000 characters'),
  })

  const [updateTpv] = useMutation(UPDATE_TPV, {
    fetchPolicy: 'network-only',
    onCompleted: (tpvData: any) => {
      setBtnShow(false)
      if (tpvData) {
        const tempDisposition: string = tpvData?.updateTpv?.disposition || ''
        setNewDisposition(tempDisposition)
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'Disposition updated successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
      }
    },
  })

  const formik = useFormik({
    initialValues: { disposition: Boolean(data?.disposition) ? data?.disposition : '' },
    validationSchema: recordingInfoSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      updateTpv({
        variables: {
          updateTpv: {
            tpvId,
            qcStatus: data.qcStatus,
            disposition: values.disposition,
          },
        },
      })
    },
  })

  const handleTab = (targetTab: any) => {
    setTab(targetTab)
    handleRecordTab(targetTab)
  }

  const handleMinutes = (obj: any) => {
    let tempVal: any = ''
    if (obj > 0) {
      tempVal = obj / 60
    } else {
      tempVal = '0'
    }
    tempVal = tempVal < 9 ? `0${tempVal}` : tempVal
    return `${tempVal}:00 Min`
  }

  const handleEdit = () => {
    setBtnShow(true)
    if (!dataFeed) {
      const disposition = {
        disposition: data?.disposition?.length > 0 ? data?.disposition : '',
      }
      formik.setValues({ ...disposition })
      setDataFeed(true)
    }
  }

  const handleDiscard = () => {
    setBtnShow(false)
    const disposition = {
      disposition:
        newDisposition.length > 0
          ? newDisposition
          : data?.disposition?.length > 0
            ? data?.disposition
            : '',
    }
    formik.setValues({ ...disposition })
  }

  const handleOnChange = (e: any, name: string) => {
    formik.setFieldValue(name, e.target.value)
  }

  return (
    <div>
      {data?.calls.length > 0 && (
        <div className='tab d-flex flex-row justify-content-between'>
          <ul
            className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
            role='tablist'
          >
            {data?.calls.map((_: any, idx: number) => {
              return (
                <li className='nav-item' key={idx}>
                  <div
                    className={clsx(`nav-link cursor-pointer text-gray-600 fs-4`, {
                      active: tab === idx,
                    })}
                    onClick={() => handleTab(idx)}
                    role='tab'
                  >
                    {`Recording ${idx + 1}`}
                  </div>
                </li>
              )
            })}
          </ul>

          <div className='d-flex align-items-center'>{/* Edit button */}</div>
        </div>
      )}

      <div className='card mt-5'>
        <div className='card-body p-0'>
          <div className='tab-content pt-3'>
            {data?.calls.map((item: any, idx: number) => {
              return (
                <div className={clsx('tab-pane', { active: tab === idx })}>
                  <div className='d-flex'>
                    {customerData?.tpvType !== 'SMS TPV' && (
                      <>
                        <div className='rec-dur-title'>
                          Duration: <span>{handleMinutes(item.callRoundedDuration)}</span>
                        </div>
                        <div className='bg-gray-300 mx-3' style={{ width: '2px' }}></div>
                      </>
                    )}

                    <div className='rec-dur-title'>
                      Date:
                      <span>{moment.utc(item.callTime).local().format('MMMM Do YYYY, hh:mm:ss a')}</span>
                    </div>
                    <div className='bg-gray-300 mx-3' style={{ width: '2px' }}></div>
                    <div className='rec-dur-title'>
                      Type:
                      <span>
                        {customerData?.tpvType === 'SMS TPV' ? 'TEXT TPV' : customerData?.tpvType}
                      </span>
                    </div>
                  </div>
                </div>
              )
            })}
            {!btnShow && (
              <>
                <div className='d-flex justify-content-between'>
                  <div className='dis-title pt-5 pb-1'>
                    Disposition:
                    {data?.isCustomerFlagged && (
                      <TooltipCommon text='Live agent flagged the TPV' coverClassName='d-inline'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='16'
                          height='16'
                          fill='red'
                          className='bi bi-exclamation-octagon ms-2'
                          viewBox='0 0 16 16'
                        >
                          <path d='M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z' />
                          <path d='M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z' />
                        </svg>
                      </TooltipCommon>
                    )}
                  </div>
                  {!btnShow &&
                    (data?.calls?.length > 0 || tpvStatus === 'NO_TPV') && (
                      <button
                        type='button'
                        className='btn btn-primary text-white btn-active-color-primary btn-md me-1'
                        onClick={() => handleEdit()}
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                      >
                        Edit
                      </button>
                    )}
                </div>
                <textarea
                  readOnly={!btnShow}
                  className='form-control form-control-lg form-control-solid resize-none min-h-100px mt-5'
                  placeholder='Enter Disposition'
                  maxLength={2000}
                  {...formik.getFieldProps('disposition')}
                  onChange={(e) => handleOnChange(e, 'disposition')}
                  rows={4}
                ></textarea>
              </>
            )}
            {btnShow && (
              <form onSubmit={formik.handleSubmit}>
                <Col sm={12} md={12} className='pb-5 pr-0 pt-5 cust-dispo'>
                  <label className='d-flex justify-content-between align-items-center mb-2'>
                    <span className='fs-6 fw-semibold lh-23px'>Disposition: </span>
                  </label>
                  <textarea
                    className='form-control form-control-lg form-control-solid resize-none min-h-100px'
                    placeholder='Enter description'
                    maxLength={2000}
                    {...formik.getFieldProps('disposition')}
                    onChange={(e) => handleOnChange(e, 'disposition')}
                    rows={4}
                  ></textarea>
                </Col>
                <div className='d-flex flex-stack pt-5'>
                  <div className='me-2'></div>
                  <div className='d-flex'>
                    <button
                      type='reset'
                      onClick={() => handleDiscard()}
                      className='btn btn-light me-3'
                    >
                      Discard
                    </button>
                    <button
                      type='submit'
                      className={`btn btn-lg btn-primary ${btnShow ? null : 'd-none'}`}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecordingInfo
